
$(function(){

  $('.selectpicker').selectpicker();
  $('.phoneNumber').css("padding-left","70px");
  $('.iti__selected-dial-code').html('+');
  $('#formCallback').validate({
    rules: {
      firstName: {
        required: true
      },
      lastName: {
        required: true
      },
      phoneNumber: {
        required: true,
        minlength: 8,
        number: true,
      },  
      countryCode : {
        required: true,
      }  
    },
    messages: {
      countryCode: "Please select country code.",
    },
    
    submitHandler: function (form) {
      $.ajax({
        url: 'inc/actions/_PostCallback.php',
        method: 'POST',
        dataType: 'json',
        data: $(form).serialize(),
        beforeSend: function () {
          $(form).find('input[type="submit"]').attr('disabled', true);
        },
        success: function (response) {
          if (response.status == "success") {
              window.location.href = '/thank-you.php';
              $('.form-control').val('');
          }
        },
        complete: function () {
          $(form).find('input[type="submit"]').attr('disabled', false);
        }
      });
    }
  });

  $('#formReview').validate({
    ignore: "",
    rules: {
      firstName: {
        required: true
      },
      lastName: {
        required: true
      },
      email: {
        required: true
      },
      phoneNumber: {
        required: true,
        minlength: 8,
        number: true
      },
      countryCode : {
        required: true,
      }  
    },
    messages: {
      countryCode: "Please select country code.",
    },
    submitHandler: function (form) {
      $.ajax({
        url: 'inc/actions/_PostReview.php',
        method: 'POST',
        dataType: 'json',
        data: $(form).serialize(),
        beforeSend: function () {
          $(form).find('input[type="submit"]').attr('disabled', true);
        },
        success: function (response) {
          if (response.status == "success") {
            window.location.href = '/thank-you.php';
            $('.form-control').val('');
          }
        },
        complete: function () {
          $(form).find('input[type="submit"]').attr('disabled', false);
        }
      });
    }
  });
  $('#formSearch').validate({
    rules: {
      firstName: {
        required: true
      },
      lastName: {
        required: true
      },
      email: {
        required: true
      },
      phoneNumber: {
        required: true,
        minlength: 8,
        number: true
      },
      countryCode : {
        required: true,
      }  
    },
    messages: {
      countryCode: "Please select country code.",
    },
    submitHandler: function (form) {
      $.ajax({
        url: 'inc/actions/_PostSearch.php',
        method: 'POST',
        dataType: 'json',
        data: $(form).serialize(),
        beforeSend: function () {
          $(form).find('input[type="submit"]').attr('disabled', true);
        },
        success: function (response) {
          if (response.status == "success") {
              window.location.href = '/thank-you.php';
              $('.form-control').val('');
          }
        },
        complete: function () {
          $(form).find('input[type="submit"]').attr('disabled', false);
        }
      });
    }
  });
  $(document).on('click', '.scroll-to', function (e) {
    var id = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(id).offset().top
    });
    e.preventDefault();
  });

  $(".collapse.show").each(function(){
    $(this).prev(".card-header").find(".fa").addClass("fa-minus").removeClass("fa-plus");
  });
  
  // Toggle plus minus icon on show hide of collapse element
  $(".collapse").on('show.bs.collapse', function(){
    $(this).prev(".card-header").find(".fa").removeClass("fa-plus").addClass("fa-minus");
  }).on('hide.bs.collapse', function(){
    $(this).prev(".card-header").find(".fa").removeClass("fa-minus").addClass("fa-plus");
  });

});

$(".countryCode").prepend("<option value='' selected='selected'>+</option>");
$('.phoneNumber').each(function(){
  //$('.countryCode').val('+44');
  
  var input = document.querySelector('#' + $(this).attr('id'));
  window.intlTelInput(input, {
      initialCountry: "auto",
      separateDialCode: true,
      
  });
  input.addEventListener('countrychange', function(e) {
    console.log($(input).parents('.form-group'));
    $(input).parents('.form-group').find('.countryCode').val($(input).parents('.form-group').find('.iti__selected-dial-code').html());
  });
});
